import Image from "components/Image";

import classes from "./ImageSlider.module.scss";

const ResponsiveImage = ({
  src,
  alt,
  isOnStock,
}: {
  src: string;
  alt: string;
  isOnStock?: boolean;
}) => (
  <div
    className={
      isOnStock
        ? classes["responsive-image"]
        : classes["responsive-image--out-of-stock"]
    }
  >
    <Image width={317} height={317} layout="responsive" src={src} alt={alt} />
  </div>
);
export default ResponsiveImage;
